import { toast } from '@approvalmax/ui/src/components';
import { hooks, objectHelpers } from '@approvalmax/utils';
import { useCallback } from 'react';
import { useToggle } from 'react-use';
import { routingService } from 'services/routing';
import { useCompleteSlackConnect } from 'shared/data/slack/v1';

import { messages } from '../messages';

export const useSlackAuthConnectPageData = () => {
    const [showSuccess, toggleShowSuccess] = useToggle(false);

    const [code] = hooks.useQueryParam('code');
    const [state] = hooks.useQueryParam('state');

    const { data, mutate, isLoading } = useCompleteSlackConnect({
        onSuccess: toggleShowSuccess,
        onError: (error) => {
            if (objectHelpers.has(error, 'type')) {
                switch (error.type) {
                    case '/problems/auth-state-not-found':
                        toast.error(messages.errorAuthStateNotFound);
                        break;

                    case '/problems/user-already-connected':
                        toast.error(messages.errorUserAlreadyConnected);
                        break;

                    case '/problems/slack-auth-failed':
                        toast.error(messages.errorAuthFailed);
                        break;
                }
            } else {
                toast.error(messages.errorConnection);
            }
        },
    });

    const handleComplete = useCallback(
        (watchCompanyIds: string[]) => {
            mutate({ body: { code, state, watchCompanyIds } });
        },
        [code, mutate, state]
    );

    const handleCancel = useCallback(() => {
        routingService.reloadToDefaultPath();
    }, []);

    const handleOpenSlack = useCallback(() => {
        if (data?.appDeepLink) {
            window.location.href = data.appDeepLink;
        }
    }, [data]);

    return {
        isLoading,
        showSuccess,
        handleCancel,
        handleComplete,
        handleOpenSlack,
    };
};
